const errormsg = {
  ERROR_MSG_REPLACE: '|MSG|',
  SYSTEM_ERROR_TEMPLATE:
    'エラーメッセージ：|MSG|' +
    '\n\nこのエラーについてのお問い合わせは、上記のエラーメッセージをご記入の上こちらのアドレスまでお願いいたします。' +
    '\nメール：support@lecheck.jp'
};

export default errormsg;
